module.exports = __webpack_public_path__ + "img/exhibits4.b5fd2a90.png";